<template>
  <div class="leads-enq-deals-page make-smaller-tabber">
    <base-breadcrumb-bar
      :id="dealId"
      :tabItems="tabs"
      :tab.sync="tab"
      :initialTab="initialTab"
      :pageTitle="'All Leads'"
    >
      <template v-slot:filterBlock>
        <enquiry-filter :enquiryFilters.sync="enquiryOptions" v-if="tab == 0" />
        <lead-filter :leadFilters.sync="leadOptions" v-if="tab == 1" />

        <lead-filter
          :leadFilters.sync="investorOptions"
          v-if="tab == 2"
          :onlyInvestor="true"
        />

        <deal-filter :dealFilters.sync="dealOptions" v-if="tab == 3" />
        <expiry-filter :expiryFilters.sync="tenantOptions" v-if="tab == 4" />
      </template>
    </base-breadcrumb-bar>

    <lead-single-card
      v-if="leadId"
      :id="leadId"
      :refreshTable.sync="dataChanged"
    />

    <div v-if="!dealId">
      <div v-if="tab == 0">
        <enquiry-section :enquiryOptions="enquiryOptions" />
      </div>

      <div v-if="tab == 1">
        <lead-section :leadOptions="leadOptions" />
      </div>

      <div v-if="tab == 2">
        <lead-section :leadOptions="investorOptions" :onlyInvestor="true" />
      </div>

      <div v-if="tab == 3">
        <deal-section :dealOptions="dealOptions" :showAnalytics="true" />
      </div>

      <div v-if="tab == 4">
        <tenant-section :tenantOptions="tenantOptions" :expiryMode="true" />
      </div>
    </div>

    <div v-else>
      <deals-view :id="dealId" />
    </div>
  </div>
</template>

<script>
import EnquiryFilter from "@/components/Base/LeadsDeals/EnquiryFilter";
import LeadFilter from "@/components/Base/LeadsDeals/LeadFilter";
import DealFilter from "@/components/Base/LeadsDeals/DealFilter";
import ExpiryFilter from "@/components/Base/LeadsDeals/ExpiryFilter";

import EnquirySection from "@/components/Base/LeadsDeals/EnquirySection.vue";
import LeadSection from "@/components/Base/LeadsDeals/LeadSection.vue";
import DealSection from "@/components/Base/LeadsDeals/DealSection.vue";
import LeadSingleCard from "@/components/Base/LeadsDeals/LeadSingleCard.vue";
import TenantSection from "@/components/Base/Property/PropertyBlocks/BuildingBlocks/TenantSection";

import DealsView from "@/components/Base/LeadsDeals/DealsView.vue";

export default {
  components: {
    EnquiryFilter,
    LeadFilter,
    DealFilter,
    ExpiryFilter,
    EnquirySection,
    LeadSection,
    DealSection,
    DealsView,
    LeadSingleCard,
    TenantSection,
  },
  name: "Leads",
  data() {
    return {
      dealId: null,
      leadId: null,
      isLoading: false,

      enquiryOptions: {},
      leadOptions: {},
      investorOptions: {},
      dealOptions: {},
      tenantOptions: {},

      tabs: [
        { text: "Uncontacted", icon: "" },
        { text: "Active", icon: "" },
        { text: "Investors", icon: "" },
        { text: "Deals", icon: "" },
        { text: "Lease Expiry", icon: "" },
      ],

      tab: 0,
      initialTab: 0,

      dataChanged: null,
    };
  },

  methods: {
    setUrlFromRoute() {
      // Use vue-router as the source of truth (works in SSR + avoids relying on window.location)
      const query = this.$route && this.$route.query ? this.$route.query : {};
      const hash =
        this.$route && typeof this.$route.hash === "string"
          ? this.$route.hash
          : "";

      // Example: /leads?id=123
      this.leadId = query.id ? String(query.id) : null;

      // Example: /leads#456
      const cleanedHash = hash.startsWith("#") ? hash.slice(1) : hash;
      this.dealId = cleanedHash && cleanedHash.length > 0 ? cleanedHash : null;

      // If you later need this:
      // const showAddDeal = !!query.showAddDeal;
    },
  },

  watch: {
    leadOptions: {
      handler(newVal, oldVal) {},
      deep: true,
    },
    dealOptions: {
      handler(newVal, oldVal) {},
      deep: true,
    },
    $route(to, from) {
      this.setUrlFromRoute();
    },
  },

  created() {
    this.setUrlFromRoute();
  },
};
</script>

<style lang="scss">
.v-menu__content {
  box-shadow: none !important;
  margin-top: 8px !important;
}

.leads-enq-deals-page .breadcrumb-card .v-tabs {
  overflow: auto;
  padding: 0 4px;
}

.leads-enq-deals-page .v-tabs::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
</style>
